import React from 'react';
import { Box, Heading } from '@zillow/constellation-10';
import { StyledFiltersModuleContainer, StyledHeader, StyledViewByModuleContainer } from './StyledComponents';
import RentalJourneyFiltersSkeleton from '../RentalJourneyFilters/skeleton';
import FiltersPopoverSkeleton from '../FiltersPopover/skeleton';
import FoldersModuleSkeleton from '../FoldersModule/skeleton';
import useDevices from '../../hooks/useDevices';
import { RentalJourneyFiltersWrapperStyles } from '.';

const InboxHeaderSkeleton = (): JSX.Element => {
  const { isMobileView } = useDevices();

  return (
    <StyledHeader $hideOnMobile={false} $isMobile={isMobileView}>
      <Heading level={1} fontFamily="heading-alt" css={{ gridColumn: '1/7', textStyle: { xlDown: 'h4', xl: 'h3' } }}>
        Messages
      </Heading>

      <Box css={RentalJourneyFiltersWrapperStyles}>
        <RentalJourneyFiltersSkeleton />
      </Box>

      <StyledFiltersModuleContainer>
        <FiltersPopoverSkeleton />
      </StyledFiltersModuleContainer>

      <StyledViewByModuleContainer>
        <FoldersModuleSkeleton />
      </StyledViewByModuleContainer>
    </StyledHeader>
  );
};

export default InboxHeaderSkeleton;
